import { Blocs } from '@business/blocs';
import { GCCalendarEventObjectType } from '@business/entities/gc_calendar';
import { OrgId } from '@business/entities/organization';
import { BaseBloc } from '@core/utils/bloc';
import { resolve } from '@core/utils/ioc';
import { LoadingState } from '@core/utils/repository/loading_state';
import { forkJoin } from 'rxjs';

export class GCModulesCalendarBloc extends BaseBloc {
  private readonly calendarBloc = resolve(Blocs.gcModuleCalendar);
  private readonly teamBloc = resolve(Blocs.team);
  private readonly userBloc = resolve(Blocs.user);
  private readonly calendarEventBloc = resolve(Blocs.gcCalendarEvent);

  constructor(private objectType = GCCalendarEventObjectType.Organization, private objectId?: string) {
    super();
  }

  events$ = this.calendarBloc.events$;
  loading = new LoadingState();

  teams$ = this.teamBloc.teams$;
  users$ = this.userBloc.staff$;

  onInit() {
    return forkJoin([
      this.calendarBloc.events({
        objectId: this.objectId,
        objectType: this.objectType,
        startTime: new Date().valueOf() / 1000 - 30 * 60,
        endTime: new Date().valueOf() / 1000 + 30 * 60,
      }),
      this.teamBloc.fetchTeams(),
      this.userBloc.fetchUsers(),
    ]).pipe(this.loading.run());
  }

  fetchEvents = this.calendarBloc.events;
  resetEvents = this.calendarBloc.resetEvents;

  addEvent = this.calendarBloc.addEvent;
  editEvent = this.calendarBloc.editEvent;
  deleteEvent = this.calendarBloc.deleteEvent;
  dragEvent = this.calendarBloc.dragEvent;

  addEventToGoogleCalendar = this.calendarBloc.addEventToGoogleCalendar;

  onAllEventsReload(objectType?: GCCalendarEventObjectType, objectId?: string, orgId?: OrgId, startTime?: number, endTime?: number) {
    return this.calendarEventBloc
      .allEvents({
        objectId: objectId,
        objectType: objectType,
        orgId: orgId,
        startTime: startTime,
        endTime: endTime,
      })
      .subscribe();
  }
}
